import React, { useState, useEffect, forwardRef } from "react";
import { RCCGrid } from "react-common-components";
import Loader from "src/components/Loader";
import ChartIndicatorsContainer from "src/pages/Indicators/Panel/components/ChartIndicatorsContainer";
import mountDefaultValueChart from "src/pages/Indicators/Panel/components/ChartIndicatorsContainer/mountDefaultValueChart";
import mountDefaultValueAccumulatedChart from "src/pages/Indicators/Panel/components/ChartIndicatorsContainer/mountDefaultValuesAccumulated";
import mountDefaultValueTable from "src/pages/Indicators/Panel/components/ChartIndicatorsContainer/mountDefaultValueTable";
import ChartIndicatorsTitle from "src/pages/Indicators/Panel/components/ChartIndicatorsTitle";
import { IChartConfigIndicators, IChartIndicators, IChartTableIndicators, IFieldsChart } from "src/pages/Indicators/Panel/components/ModalIndicatorChart/interface";
import { IChartContentIndicatorsPresentationPanel } from "./interface";
import ContainerChartContentIndicatorsPanel from "./styles";

const ChartContent: React.ForwardRefRenderFunction<any, IChartContentIndicatorsPresentationPanel> = ({
	data,
	tendencyString,
	configs,
	configShowGoals,
	openValuesOfPeriodIndicator
}, ref) => {
	const [dataTable, setDataTable] = useState<IChartTableIndicators[]>([]);
	const [dataChart, setDataChart] = useState<IChartIndicators[]>([]);
	const [dataChartAccumulated, setDataChartAccumulated] = useState<IChartIndicators[]>([]);
	const [fieldsChart, setFieldsChart] = useState<IFieldsChart[]>([]);
	const [fieldsChartAccumulated, setFieldsChartAccumulated] = useState<IFieldsChart[]>([]);
	const [configCharts] = useState<IChartConfigIndicators>(data.indicatorChartConfigs);
	const [loading, setLoading] = useState(true);
	
	const mountCharts = async () => {
		setLoading(true);
		async function mount(){
			mountDefaultValueChart(configShowGoals !== undefined ? 
				data.indicatorChartValues.map((x) => ({
					name: x.name,
					hasFCA: x.hasFCA,
					values: x.values.map((val) => {
						let valShowInChart = val.showInChart;
		
						if(val.indicatorGoalType === "S" && configShowGoals.showGoalImprovementInGraphic !== undefined)
							valShowInChart = configShowGoals.showGoalImprovementInGraphic;
						else if(val.indicatorGoalType === "C" && configShowGoals.showGoalCompetitivenessInGraphic !== undefined)
							valShowInChart = configShowGoals.showGoalCompetitivenessInGraphic;
						else if(val.indicatorGoalType === "O" && configShowGoals.showGoalCommitmentInGraphic !== undefined)
							valShowInChart = configShowGoals.showGoalCommitmentInGraphic;	
		
						return{
							...val,
							showInChart: valShowInChart
						};
					})
				}))
				: data.indicatorChartValues, setFieldsChart, setDataChart, tendencyString);
			if(data.indicatorChartValuesAccumulated && data.indicatorChartValuesAccumulated !== null && data.indicatorChartValuesAccumulated.length > 0)
	            mountDefaultValueAccumulatedChart(configShowGoals !== undefined ? 
					data.indicatorChartValuesAccumulated.map((x) => ({
						name: x.name,
						hasFCA: x.hasFCA,
						values: x.values.map((val) => {
							let valShowInChart = val.showInChart;
		
							if(val.indicatorGoalType === "S" && configShowGoals.showGoalImprovementInGraphic !== undefined)
								valShowInChart = configShowGoals.showGoalImprovementInGraphic;
							else if(val.indicatorGoalType === "C" && configShowGoals.showGoalCompetitivenessInGraphic !== undefined)
								valShowInChart = configShowGoals.showGoalCompetitivenessInGraphic;
							else if(val.indicatorGoalType === "O" && configShowGoals.showGoalCommitmentInGraphic !== undefined)
								valShowInChart = configShowGoals.showGoalCommitmentInGraphic;	
		
							return{
								...val,
								showInChart: valShowInChart
							};
						})
					}))
					: data.indicatorChartValuesAccumulated, setFieldsChartAccumulated, setDataChartAccumulated, tendencyString);
			mountDefaultValueTable(data.indicatorChartValues, data.indicatorChartValuesAccumulated, setDataTable, tendencyString);
		}
		await mount();
		setLoading(false);
	};

	const onClickChartAreaBarLine = (periodId: number, isPresentation: boolean) => openValuesOfPeriodIndicator && openValuesOfPeriodIndicator(data.iqc001Id, data.iqc001Descricao, periodId, isPresentation);

	useEffect(() => {
		mountCharts();
	}, [configShowGoals]);
	
	return (
		<ContainerChartContentIndicatorsPanel level={data.iqc001Nivel} ref={ref} className="container-chart-indicator">
			<RCCGrid container justifyContent="center" item>
				<ChartIndicatorsTitle 
					title={data.iqc001Descricao}
					hideEvaluationForm={configCharts.iqc001Ocultarformaaval}
					evaluationForm={configCharts.iqc001Formaaval}
					descObjective={configCharts.iqc001Descobjetivo}
					method={configCharts.iqc001Metodo}
					measureUnit={configCharts.iqc001Taa009Descricao}
				/>
			</RCCGrid>
			{loading ? <Loader /> : 
				<ChartIndicatorsContainer 
					configCharts={{
						...configCharts,
						showAll: configs?.showAll
					}}
					dataChart={dataChart}
					dataChartAccumulated={dataChartAccumulated}
					fieldsChart={fieldsChart}
					fieldsChartAccumulated={fieldsChartAccumulated}
					onClickChartAreaBarLine={onClickChartAreaBarLine}
					dataTable={dataTable}
				/>
			}
		</ContainerChartContentIndicatorsPanel>);
};

export default forwardRef(ChartContent);
